import { useCallback } from 'react';

import { showTooltip } from '@/helpers/tooltip';
import { useGetCommonStore } from '@/store';
import { TooltipTypes } from '@/store/tooltipStore';
import { type IssuableItem, isNewlyIssuedBonus } from '../lib/isUnseenBonus';
import { BonusReceivedTooltip } from '../ui/BonusReceivedTooltip';
import { useActiveBonusesTabStore } from './activeBonusesTabStore';

type TIssuableCollection = 'bonuses' | 'freespins';

export const useNotifyBonusReceived = (): ((
  incoming: IssuableItem,
  collection: TIssuableCollection
) => void) => {
  const useCommonStore = useGetCommonStore();

  return useCallback(
    (incoming: IssuableItem, collection: TIssuableCollection) => {
      const previous = useCommonStore
        .getState()
        [collection].find((item) => item.id === incoming.id);

      if (!isNewlyIssuedBonus(incoming, previous)) return;

      if (useActiveBonusesTabStore.getState().isOpen) return;

      showTooltip({
        type: TooltipTypes.SUCCESS,
        body: <BonusReceivedTooltip />,
        pauseOnHover: true,
      });
    },
    [useCommonStore]
  );
};
